/**
 * URL-safe slug from a display name.
 * "Data Erasure Software" → "data-erasure-software"
 */
export function slugify(value) {
  return String(value || '')
    .normalize('NFKD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase()
    .replace(/&/g, ' and ')
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '')
    .replace(/-{2,}/g, '-')
}

/**
 * Unique company slug. If multiple companies share the same base slug, append -{id}.
 */
export function companySlug(name, id, allNamesWithIds = []) {
  const base = slugify(name)
  if (!base) return String(id)

  const collisions = allNamesWithIds.filter(
    (item) => slugify(item.name) === base
  )

  if (collisions.length > 1) {
    return `${base}-${id}`
  }
  return base
}
